export default __webpack_public_path__ + "static/media/7.15c2c432.png";